import React, { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import { SplashScreenProvider } from '@strac/react-client-environment'
import { ServerEnvironmentProvider } from '@strac/react-client-environment'
import { AntDesignProvider } from './theme'
import { FeathersContextProvider } from '@strac/react-client-feathers'
import { AuthContextProvider } from '@strac/react-client-auth'

import { App } from 'antd'

import './main.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import AppContextProvider from './contexts/AppContext/AppContextProvider'
import Router from './router/Router'
import { queryClient } from './services/queryClient'
// React 19 compatibility
import '@ant-design/v5-patch-for-react-19';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SplashScreenProvider>
        <ServerEnvironmentProvider>
          <AntDesignProvider>
            <FeathersContextProvider>
              <AuthContextProvider>
                <App>
                  <AppContextProvider>
                    <Router />
                  </AppContextProvider>
                </App>
              </AuthContextProvider>
            </FeathersContextProvider>
          </AntDesignProvider>
        </ServerEnvironmentProvider>
      </SplashScreenProvider>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition={'bottom-right'} position={'right'} />
    </QueryClientProvider>
  </StrictMode>
)
